import { render, staticRenderFns } from "./FactList.vue?vue&type=template&id=3f7ed2f4&functional=true"
import script from "./FactList.vue?vue&type=script&lang=js"
export * from "./FactList.vue?vue&type=script&lang=js"
import style0 from "./FactList.vue?vue&type=style&index=0&id=3f7ed2f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports